export const state = {
  // list of instruments we're interestd in 
  TRADERBASICINFO: {},
  TRADERINGINFO: {},
  OPEN_POSITION:[],
  OPEN_HOLDINGS:[],
  CLOSED_ORDER:[],  
  TRADERINGACCOUNTS:[],
  MARGIN_INFO:[],
  DEPOSIT_HISTORY:[],
  WITHDRAWAL_HISTORY:[],
  BONUS_HISTORY:[],
  BANKS_DETAIL:{},
  CARD_LIST:[],
  TICKET_LIST:[],
  DOCUMENT_LIST:[],
  TICKET_VIEW:[],
  DEPOSIT_ADDRESS: {},
  GRAPH_DATA :[],
  MARKET_STATUS:[],
  LOADER_STATUS: 0,
  OPEN_ORDERS:[],
  ORDER_HISTORY:[],
  USER_LOGS: [],
  USER_EXTRA_INFO: [],
  EXCHANGE_MSG: [],
  WATCH_LIST: [],
  SOCKET_INDICATOR: -1,
  ALL_ISINS : [],
  SCRIP_INFO:[],
  MARKET_DEPTH:{
	"bno":"2",
	"bp":"--",
	"bp1":"--",
	"bp2":"--",
	"bp3":"--",
	"bp4":"--",
	"bq":"--",
	"bq2":"--",
	"name":"dp",
	"sp":"--",
	"sp2":"--",
	"sp4":"--",
	"bs":"--",
	"bs1":"--",
	"bs2":"--",
	"bs3":"--",
	"bs4":"--",
	"type":"depth"
},
  CURRENT_TRADING_ACCOUNT:{},
  DOWNLOAD:[{
	"TradeStation": {
		"label": "FinPro Trade Station",
		"image": "Logo-FinPro_Station.png",
		"sublink": [{
				"name": "FinPro Desktop",
				"link": "downloads/fpt.exe"
			},
			{
				"name": "FinPro ios",
				"link": "https://itunes.apple.com/us/app/fx-phone/id1085679376?ls=1&mt=8"
			},
			{
				"name": "FinPro Web-Live",
				"link": "http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.202"
			},
			{
				"name": "FinPro Web-Demo",
				"link": "http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.202"
			},
			{
				"name": "FinPro Android",
				"link": "https://play.google.com/store/apps/details?id=kpdn.trader&hl=en"
			}
		]
	},
	"MetaTrader": {
		"label": "MetaTrader 4",
		"image": "live-mt4.png",
		"sublink": [{
				"name": "FinPro Desktop",
				"link": "downloads/mt4.exe"
			},
			{
				'name' : 'MT4 ios',
				'link' : 'https://itunes.apple.com/in/app/metatrader-4/id496212596?mt=8'
			},
			{
				'name' : 'MT4 Android',
				'link' : 'https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4&hl=en'
			}
		]
	},
	"ZuluTrade": {
		"label": "Zulu Trade",
		"image": "zulu.png",
		"sublink": [
			{
				'name' : 'Zulutrade Web',
				'link' : 'https://finprotrading.zulutrade.com/login'
			},
			{
				'name' : 'Zulutrade ios',
				'link' : 'http://itunes.apple.com/us/app/zulutrade/id336913058?mt=8'
			},
			{
				'name' : 'Zulutrade Android',
				'link' : 'https://play.google.com/store/apps/details?id=zulu.trade.app'
			}
		]
		}
	}],

  TRADERINGHISTORY:[],
  QRCODE:'',
  intervalid: '',
  COUNTRIES: [{"id":"1","country_code":"AF","country_name":"Afghanistan","created":"2017-05-10 11:35:33"},
{"id":"2","country_code":"AL","country_name":"Albania","created":"2017-05-10 11:35:33"},
{"id":"3","country_code":"DZ","country_name":"Algeria","created":"2017-05-10 11:35:33"},
{"id":"4","country_code":"DS","country_name":"American Samoa","created":"2017-05-10 11:35:33"},
{"id":"5","country_code":"AD","country_name":"Andorra","created":"2017-05-10 11:35:33"},
{"id":"6","country_code":"AO","country_name":"Angola","created":"2017-05-10 11:35:33"},
{"id":"7","country_code":"AI","country_name":"Anguilla","created":"2017-05-10 11:35:33"},
{"id":"8","country_code":"AQ","country_name":"Antarctica","created":"2017-05-10 11:35:33"},
{"id":"9","country_code":"AG","country_name":"Antigua and Barbuda","created":"2017-05-10 11:35:33"},
{"id":"10","country_code":"AR","country_name":"Argentina","created":"2017-05-10 11:35:33"},
{"id":"11","country_code":"AM","country_name":"Armenia","created":"2017-05-10 11:35:33"},
{"id":"12","country_code":"AW","country_name":"Aruba","created":"2017-05-10 11:35:33"},
{"id":"13","country_code":"AU","country_name":"Australia","created":"2017-05-10 11:35:33"},
{"id":"14","country_code":"AT","country_name":"Austria","created":"2017-05-10 11:35:33"},
{"id":"15","country_code":"AZ","country_name":"Azerbaijan","created":"2017-05-10 11:35:33"},
{"id":"16","country_code":"BS","country_name":"Bahamas","created":"2017-05-10 11:35:33"},
{"id":"17","country_code":"BH","country_name":"Bahrain","created":"2017-05-10 11:35:33"},
{"id":"18","country_code":"BD","country_name":"Bangladesh","created":"2017-05-10 11:35:33"},
{"id":"19","country_code":"BB","country_name":"Barbados","created":"2017-05-10 11:35:33"},
{"id":"20","country_code":"BY","country_name":"Belarus","created":"2017-05-10 11:35:33"},
{"id":"21","country_code":"BE","country_name":"Belgium","created":"2017-05-10 11:35:33"},
{"id":"22","country_code":"BZ","country_name":"Belize","created":"2017-05-10 11:35:33"},
{"id":"23","country_code":"BJ","country_name":"Benin","created":"2017-05-10 11:35:33"},
{"id":"24","country_code":"BM","country_name":"Bermuda","created":"2017-05-10 11:35:33"},
{"id":"25","country_code":"BT","country_name":"Bhutan","created":"2017-05-10 11:35:33"},
{"id":"26","country_code":"BO","country_name":"Bolivia","created":"2017-05-10 11:35:33"},
{"id":"27","country_code":"BA","country_name":"Bosnia and Herzegovina","created":"2017-05-10 11:35:33"},
{"id":"28","country_code":"BW","country_name":"Botswana","created":"2017-05-10 11:35:33"},
{"id":"29","country_code":"BV","country_name":"Bouvet Island","created":"2017-05-10 11:35:33"},
{"id":"30","country_code":"BR","country_name":"Brazil","created":"2017-05-10 11:35:33"},
{"id":"31","country_code":"IO","country_name":"British Indian Ocean Territory","created":"2017-05-10 11:35:33"},
{"id":"32","country_code":"BN","country_name":"Brunei Darussalam","created":"2017-05-10 11:35:33"},
{"id":"33","country_code":"BG","country_name":"Bulgaria","created":"2017-05-10 11:35:33"},
{"id":"34","country_code":"BF","country_name":"Burkina Faso","created":"2017-05-10 11:35:33"},
{"id":"35","country_code":"BI","country_name":"Burundi","created":"2017-05-10 11:35:33"},
{"id":"36","country_code":"KH","country_name":"Cambodia","created":"2017-05-10 11:35:33"},
{"id":"37","country_code":"CM","country_name":"Cameroon","created":"2017-05-10 11:35:33"},
{"id":"38","country_code":"CA","country_name":"Canada","created":"2017-05-10 11:35:33"},
{"id":"39","country_code":"CV","country_name":"Cape Verde","created":"2017-05-10 11:35:33"},
{"id":"40","country_code":"KY","country_name":"Cayman Islands","created":"2017-05-10 11:35:33"},
{"id":"41","country_code":"CF","country_name":"Central African Republic","created":"2017-05-10 11:35:33"},
{"id":"42","country_code":"TD","country_name":"Chad","created":"2017-05-10 11:35:33"},
{"id":"43","country_code":"CL","country_name":"Chile","created":"2017-05-10 11:35:33"},
{"id":"44","country_code":"CN","country_name":"China","created":"2017-05-10 11:35:33"},
{"id":"45","country_code":"CX","country_name":"Christmas Island","created":"2017-05-10 11:35:33"},
{"id":"46","country_code":"CC","country_name":"Cocos (Keeling) Islands","created":"2017-05-10 11:35:33"},
{"id":"47","country_code":"CO","country_name":"Colombia","created":"2017-05-10 11:35:33"},
{"id":"48","country_code":"KM","country_name":"Comoros","created":"2017-05-10 11:35:33"},
{"id":"49","country_code":"CG","country_name":"Congo","created":"2017-05-10 11:35:33"},
{"id":"50","country_code":"CK","country_name":"Cook Islands","created":"2017-05-10 11:35:33"},
{"id":"51","country_code":"CR","country_name":"Costa Rica","created":"2017-05-10 11:35:33"},
{"id":"52","country_code":"HR","country_name":"Croatia (Hrvatska)","created":"2017-05-10 11:35:33"},
{"id":"53","country_code":"CU","country_name":"Cuba","created":"2017-05-10 11:35:33"},
{"id":"54","country_code":"CY","country_name":"Cyprus","created":"2017-05-10 11:35:33"},
{"id":"55","country_code":"CZ","country_name":"Czech Republic","created":"2017-05-10 11:35:33"},
{"id":"56","country_code":"DK","country_name":"Denmark","created":"2017-05-10 11:35:33"},
{"id":"57","country_code":"DJ","country_name":"Djibouti","created":"2017-05-10 11:35:33"},
{"id":"58","country_code":"DM","country_name":"Dominica","created":"2017-05-10 11:35:33"},
{"id":"59","country_code":"DO","country_name":"Dominican Republic","created":"2017-05-10 11:35:33"},
{"id":"60","country_code":"TP","country_name":"East Timor","created":"2017-05-10 11:35:33"},
{"id":"61","country_code":"EC","country_name":"Ecuador","created":"2017-05-10 11:35:33"},
{"id":"62","country_code":"EG","country_name":"Egypt","created":"2017-05-10 11:35:33"},
{"id":"63","country_code":"SV","country_name":"El Salvador","created":"2017-05-10 11:35:33"},
{"id":"64","country_code":"GQ","country_name":"Equatorial Guinea","created":"2017-05-10 11:35:33"},
{"id":"65","country_code":"ER","country_name":"Eritrea","created":"2017-05-10 11:35:33"},
{"id":"66","country_code":"EE","country_name":"Estonia","created":"2017-05-10 11:35:33"},
{"id":"67","country_code":"ET","country_name":"Ethiopia","created":"2017-05-10 11:35:33"},
{"id":"68","country_code":"FK","country_name":"Falkland Islands (Malvinas)","created":"2017-05-10 11:35:33"},
{"id":"69","country_code":"FO","country_name":"Faroe Islands","created":"2017-05-10 11:35:33"},
{"id":"70","country_code":"FJ","country_name":"Fiji","created":"2017-05-10 11:35:33"},
{"id":"71","country_code":"FI","country_name":"Finland","created":"2017-05-10 11:35:33"},
{"id":"72","country_code":"FR","country_name":"France","created":"2017-05-10 11:35:33"},
{"id":"73","country_code":"FX","country_name":"France, Metropolitan","created":"2017-05-10 11:35:33"},
{"id":"74","country_code":"GF","country_name":"French Guiana","created":"2017-05-10 11:35:33"},
{"id":"75","country_code":"PF","country_name":"French Polynesia","created":"2017-05-10 11:35:33"},
{"id":"76","country_code":"TF","country_name":"French Southern Territories","created":"2017-05-10 11:35:33"},
{"id":"77","country_code":"GA","country_name":"Gabon","created":"2017-05-10 11:35:33"},
{"id":"78","country_code":"GM","country_name":"Gambia","created":"2017-05-10 11:35:33"},
{"id":"79","country_code":"GE","country_name":"Georgia","created":"2017-05-10 11:35:33"},
{"id":"80","country_code":"DE","country_name":"Germany","created":"2017-05-10 11:35:33"},
{"id":"81","country_code":"GH","country_name":"Ghana","created":"2017-05-10 11:35:33"},
{"id":"82","country_code":"GI","country_name":"Gibraltar","created":"2017-05-10 11:35:33"},
{"id":"83","country_code":"GK","country_name":"Guernsey","created":"2017-05-10 11:35:33"},
{"id":"84","country_code":"GR","country_name":"Greece","created":"2017-05-10 11:35:33"},
{"id":"85","country_code":"GL","country_name":"Greenland","created":"2017-05-10 11:35:33"},
{"id":"86","country_code":"GD","country_name":"Grenada","created":"2017-05-10 11:35:33"},
{"id":"87","country_code":"GP","country_name":"Guadeloupe","created":"2017-05-10 11:35:33"},
{"id":"88","country_code":"GU","country_name":"Guam","created":"2017-05-10 11:35:33"},
{"id":"89","country_code":"GT","country_name":"Guatemala","created":"2017-05-10 11:35:33"},
{"id":"90","country_code":"GN","country_name":"Guinea","created":"2017-05-10 11:35:33"},
{"id":"91","country_code":"GW","country_name":"Guinea-Bissau","created":"2017-05-10 11:35:33"},
{"id":"92","country_code":"GY","country_name":"Guyana","created":"2017-05-10 11:35:33"},
{"id":"93","country_code":"HT","country_name":"Haiti","created":"2017-05-10 11:35:33"},
{"id":"94","country_code":"HM","country_name":"Heard and Mc Donald Islands","created":"2017-05-10 11:35:33"},
{"id":"95","country_code":"HN","country_name":"Honduras","created":"2017-05-10 11:35:33"},
{"id":"96","country_code":"HK","country_name":"Hong Kong","created":"2017-05-10 11:35:33"},
{"id":"97","country_code":"HU","country_name":"Hungary","created":"2017-05-10 11:35:33"},
{"id":"98","country_code":"IS","country_name":"Iceland","created":"2017-05-10 11:35:33"},
{"id":"99","country_code":"IN","country_name":"India","created":"2017-05-10 11:35:33"},
{"id":"100","country_code":"IM","country_name":"Isle of Man","created":"2017-05-10 11:35:33"},
{"id":"101","country_code":"ID","country_name":"Indonesia","created":"2017-05-10 11:35:33"},
{"id":"102","country_code":"IR","country_name":"Iran (Islamic Republic of)","created":"2017-05-10 11:35:33"},
{"id":"103","country_code":"IQ","country_name":"Iraq","created":"2017-05-10 11:35:33"},
{"id":"104","country_code":"IE","country_name":"Ireland","created":"2017-05-10 11:35:33"},
{"id":"105","country_code":"IL","country_name":"Israel","created":"2017-05-10 11:35:33"},
{"id":"106","country_code":"IT","country_name":"Italy","created":"2017-05-10 11:35:33"},
{"id":"107","country_code":"CI","country_name":"Ivory Coast","created":"2017-05-10 11:35:33"},
{"id":"108","country_code":"JE","country_name":"Jersey","created":"2017-05-10 11:35:33"},
{"id":"109","country_code":"JM","country_name":"Jamaica","created":"2017-05-10 11:35:33"},
{"id":"110","country_code":"JP","country_name":"Japan","created":"2017-05-10 11:35:33"},
{"id":"111","country_code":"JO","country_name":"Jordan","created":"2017-05-10 11:35:33"},
{"id":"112","country_code":"KZ","country_name":"Kazakhstan","created":"2017-05-10 11:35:33"},
{"id":"113","country_code":"KE","country_name":"Kenya","created":"2017-05-10 11:35:33"},
{"id":"114","country_code":"KI","country_name":"Kiribati","created":"2017-05-10 11:35:33"},
{"id":"115","country_code":"KP","country_name":"Korea, Democratic People's Republic of","created":"2017-05-10 11:35:33"},
{"id":"116","country_code":"KR","country_name":"Korea, Republic of","created":"2017-05-10 11:35:33"},
{"id":"117","country_code":"XK","country_name":"Kosovo","created":"2017-05-10 11:35:33"},
{"id":"118","country_code":"KW","country_name":"Kuwait","created":"2017-05-10 11:35:33"},
{"id":"119","country_code":"KG","country_name":"Kyrgyzstan","created":"2017-05-10 11:35:33"},
{"id":"120","country_code":"LA","country_name":"Lao People's Democratic Republic","created":"2017-05-10 11:35:33"},
{"id":"121","country_code":"LV","country_name":"Latvia","created":"2017-05-10 11:35:33"},
{"id":"122","country_code":"LB","country_name":"Lebanon","created":"2017-05-10 11:35:33"},
{"id":"123","country_code":"LS","country_name":"Lesotho","created":"2017-05-10 11:35:33"},
{"id":"124","country_code":"LR","country_name":"Liberia","created":"2017-05-10 11:35:33"},
{"id":"125","country_code":"LY","country_name":"Libyan Arab Jamahiriya","created":"2017-05-10 11:35:33"},
{"id":"126","country_code":"LI","country_name":"Liechtenstein","created":"2017-05-10 11:35:33"},
{"id":"127","country_code":"LT","country_name":"Lithuania","created":"2017-05-10 11:35:33"},
{"id":"128","country_code":"LU","country_name":"Luxembourg","created":"2017-05-10 11:35:33"},
{"id":"129","country_code":"MO","country_name":"Macau","created":"2017-05-10 11:35:33"},
{"id":"130","country_code":"MK","country_name":"Macedonia","created":"2017-05-10 11:35:33"},
{"id":"131","country_code":"MG","country_name":"Madagascar","created":"2017-05-10 11:35:33"},
{"id":"132","country_code":"MW","country_name":"Malawi","created":"2017-05-10 11:35:33"},
{"id":"133","country_code":"MY","country_name":"Malaysia","created":"2017-05-10 11:35:33"},
{"id":"134","country_code":"MV","country_name":"Maldives","created":"2017-05-10 11:35:33"},
{"id":"135","country_code":"ML","country_name":"Mali","created":"2017-05-10 11:35:33"},
{"id":"136","country_code":"MT","country_name":"Malta","created":"2017-05-10 11:35:33"},
{"id":"137","country_code":"MH","country_name":"Marshall Islands","created":"2017-05-10 11:35:33"},
{"id":"138","country_code":"MQ","country_name":"Martinique","created":"2017-05-10 11:35:33"},
{"id":"139","country_code":"MR","country_name":"Mauritania","created":"2017-05-10 11:35:33"},
{"id":"140","country_code":"MU","country_name":"Mauritius","created":"2017-05-10 11:35:33"},
{"id":"141","country_code":"TY","country_name":"Mayotte","created":"2017-05-10 11:35:33"},
{"id":"142","country_code":"MX","country_name":"Mexico","created":"2017-05-10 11:35:33"},
{"id":"143","country_code":"FM","country_name":"Micronesia, Federated States of","created":"2017-05-10 11:35:33"},
{"id":"144","country_code":"MD","country_name":"Moldova, Republic of","created":"2017-05-10 11:35:33"},
{"id":"145","country_code":"MC","country_name":"Monaco","created":"2017-05-10 11:35:33"},
{"id":"146","country_code":"MN","country_name":"Mongolia","created":"2017-05-10 11:35:33"},
{"id":"147","country_code":"ME","country_name":"Montenegro","created":"2017-05-10 11:35:33"},
{"id":"148","country_code":"MS","country_name":"Montserrat","created":"2017-05-10 11:35:33"},
{"id":"149","country_code":"MA","country_name":"Morocco","created":"2017-05-10 11:35:33"},
{"id":"150","country_code":"MZ","country_name":"Mozambique","created":"2017-05-10 11:35:33"},
{"id":"151","country_code":"MM","country_name":"Myanmar","created":"2017-05-10 11:35:33"},
{"id":"152","country_code":"NA","country_name":"Namibia","created":"2017-05-10 11:35:33"},
{"id":"153","country_code":"NR","country_name":"Nauru","created":"2017-05-10 11:35:33"},
{"id":"154","country_code":"NP","country_name":"Nepal","created":"2017-05-10 11:35:33"},
{"id":"155","country_code":"NL","country_name":"Netherlands","created":"2017-05-10 11:35:33"},
{"id":"156","country_code":"AN","country_name":"Netherlands Antilles","created":"2017-05-10 11:35:33"},
{"id":"157","country_code":"NC","country_name":"New Caledonia","created":"2017-05-10 11:35:33"},
{"id":"158","country_code":"NZ","country_name":"New Zealand","created":"2017-05-10 11:35:33"},
{"id":"159","country_code":"NI","country_name":"Nicaragua","created":"2017-05-10 11:35:33"},
{"id":"160","country_code":"NE","country_name":"Niger","created":"2017-05-10 11:35:33"},
{"id":"161","country_code":"NG","country_name":"Nigeria","created":"2017-05-10 11:35:33"},
{"id":"162","country_code":"NU","country_name":"Niue","created":"2017-05-10 11:35:33"},
{"id":"163","country_code":"NF","country_name":"Norfolk Island","created":"2017-05-10 11:35:33"},
{"id":"164","country_code":"MP","country_name":"Northern Mariana Islands","created":"2017-05-10 11:35:33"},
{"id":"165","country_code":"NO","country_name":"Norway","created":"2017-05-10 11:35:33"},
{"id":"166","country_code":"OM","country_name":"Oman","created":"2017-05-10 11:35:33"},
{"id":"167","country_code":"PK","country_name":"Pakistan","created":"2017-05-10 11:35:33"},
{"id":"168","country_code":"PW","country_name":"Palau","created":"2017-05-10 11:35:33"},
{"id":"169","country_code":"PS","country_name":"Palestine","created":"2017-05-10 11:35:33"},
{"id":"170","country_code":"PA","country_name":"Panama","created":"2017-05-10 11:35:33"},
{"id":"171","country_code":"PG","country_name":"Papua New Guinea","created":"2017-05-10 11:35:33"},
{"id":"172","country_code":"PY","country_name":"Paraguay","created":"2017-05-10 11:35:33"},
{"id":"173","country_code":"PE","country_name":"Peru","created":"2017-05-10 11:35:33"},
{"id":"174","country_code":"PH","country_name":"Philippines","created":"2017-05-10 11:35:33"},
{"id":"175","country_code":"PN","country_name":"Pitcairn","created":"2017-05-10 11:35:33"},
{"id":"176","country_code":"PL","country_name":"Poland","created":"2017-05-10 11:35:33"},
{"id":"177","country_code":"PT","country_name":"Portugal","created":"2017-05-10 11:35:33"},
{"id":"178","country_code":"PR","country_name":"Puerto Rico","created":"2017-05-10 11:35:33"},
{"id":"179","country_code":"QA","country_name":"Qatar","created":"2017-05-10 11:35:33"},
{"id":"180","country_code":"RE","country_name":"Reunion","created":"2017-05-10 11:35:33"},
{"id":"181","country_code":"RO","country_name":"Romania","created":"2017-05-10 11:35:33"},
{"id":"182","country_code":"RU","country_name":"Russian Federation","created":"2017-05-10 11:35:33"},
{"id":"183","country_code":"RW","country_name":"Rwanda","created":"2017-05-10 11:35:33"},
{"id":"184","country_code":"KN","country_name":"Saint Kitts and Nevis","created":"2017-05-10 11:35:33"},
{"id":"185","country_code":"LC","country_name":"Saint Lucia","created":"2017-05-10 11:35:33"},
{"id":"186","country_code":"VC","country_name":"Saint Vincent and the Grenadines","created":"2017-05-10 11:35:33"},
{"id":"187","country_code":"WS","country_name":"Samoa","created":"2017-05-10 11:35:33"},
{"id":"188","country_code":"SM","country_name":"San Marino","created":"2017-05-10 11:35:33"},
{"id":"189","country_code":"ST","country_name":"Sao Tome and Principe","created":"2017-05-10 11:35:33"},
{"id":"190","country_code":"SA","country_name":"Saudi Arabia","created":"2017-05-10 11:35:33"},
{"id":"191","country_code":"SN","country_name":"Senegal","created":"2017-05-10 11:35:33"},
{"id":"192","country_code":"RS","country_name":"Serbia","created":"2017-05-10 11:35:33"},
{"id":"193","country_code":"SC","country_name":"Seychelles","created":"2017-05-10 11:35:33"},
{"id":"194","country_code":"SL","country_name":"Sierra Leone","created":"2017-05-10 11:35:33"},
{"id":"195","country_code":"SG","country_name":"Singapore","created":"2017-05-10 11:35:33"},
{"id":"196","country_code":"SK","country_name":"Slovakia","created":"2017-05-10 11:35:33"},
{"id":"197","country_code":"SI","country_name":"Slovenia","created":"2017-05-10 11:35:33"},
{"id":"198","country_code":"SB","country_name":"Solomon Islands","created":"2017-05-10 11:35:33"},
{"id":"199","country_code":"SO","country_name":"Somalia","created":"2017-05-10 11:35:33"},
{"id":"200","country_code":"ZA","country_name":"South Africa","created":"2017-05-10 11:35:33"},
{"id":"201","country_code":"GS","country_name":"South Georgia South Sandwich Islands","created":"2017-05-10 11:35:33"},
{"id":"202","country_code":"ES","country_name":"Spain","created":"2017-05-10 11:35:33"},
{"id":"203","country_code":"LK","country_name":"Sri Lanka","created":"2017-05-10 11:35:33"},
{"id":"204","country_code":"SH","country_name":"St. Helena","created":"2017-05-10 11:35:33"},
{"id":"205","country_code":"PM","country_name":"St. Pierre and Miquelon","created":"2017-05-10 11:35:33"},
{"id":"206","country_code":"SD","country_name":"Sudan","created":"2017-05-10 11:35:33"},
{"id":"207","country_code":"SR","country_name":"Suriname","created":"2017-05-10 11:35:33"},
{"id":"208","country_code":"SJ","country_name":"Svalbard and Jan Mayen Islands","created":"2017-05-10 11:35:33"},
{"id":"209","country_code":"SZ","country_name":"Swaziland","created":"2017-05-10 11:35:33"},
{"id":"210","country_code":"SE","country_name":"Sweden","created":"2017-05-10 11:35:33"},
{"id":"211","country_code":"CH","country_name":"Switzerland","created":"2017-05-10 11:35:33"},
{"id":"212","country_code":"SY","country_name":"Syrian Arab Republic","created":"2017-05-10 11:35:33"},
{"id":"213","country_code":"TW","country_name":"Taiwan","created":"2017-05-10 11:35:33"},
{"id":"214","country_code":"TJ","country_name":"Tajikistan","created":"2017-05-10 11:35:33"},
{"id":"215","country_code":"TZ","country_name":"Tanzania, United Republic of","created":"2017-05-10 11:35:33"},
{"id":"216","country_code":"TH","country_name":"Thailand","created":"2017-05-10 11:35:33"},
{"id":"217","country_code":"TG","country_name":"Togo","created":"2017-05-10 11:35:33"},
{"id":"218","country_code":"TK","country_name":"Tokelau","created":"2017-05-10 11:35:33"},
{"id":"219","country_code":"TO","country_name":"Tonga","created":"2017-05-10 11:35:33"},
{"id":"220","country_code":"TT","country_name":"Trinidad and Tobago","created":"2017-05-10 11:35:33"},
{"id":"221","country_code":"TN","country_name":"Tunisia","created":"2017-05-10 11:35:33"},
{"id":"222","country_code":"TR","country_name":"Turkey","created":"2017-05-10 11:35:33"},
{"id":"223","country_code":"TM","country_name":"Turkmenistan","created":"2017-05-10 11:35:33"},
{"id":"224","country_code":"TC","country_name":"Turks and Caicos Islands","created":"2017-05-10 11:35:33"},
{"id":"225","country_code":"TV","country_name":"Tuvalu","created":"2017-05-10 11:35:33"},
{"id":"226","country_code":"UG","country_name":"Uganda","created":"2017-05-10 11:35:33"},
{"id":"227","country_code":"UA","country_name":"Ukraine","created":"2017-05-10 11:35:33"},
{"id":"228","country_code":"AE","country_name":"United Arab Emirates","created":"2017-05-10 11:35:33"},
{"id":"229","country_code":"GB","country_name":"United Kingdom","created":"2017-05-10 11:35:33"},
{"id":"230","country_code":"US","country_name":"United States","created":"2017-05-10 11:35:33"},
{"id":"231","country_code":"UM","country_name":"United States minor outlying islands","created":"2017-05-10 11:35:33"},
{"id":"232","country_code":"UY","country_name":"Uruguay","created":"2017-05-10 11:35:33"},
{"id":"233","country_code":"UZ","country_name":"Uzbekistan","created":"2017-05-10 11:35:33"},
{"id":"234","country_code":"VU","country_name":"Vanuatu","created":"2017-05-10 11:35:33"},
{"id":"235","country_code":"VA","country_name":"Vatican City State","created":"2017-05-10 11:35:33"},
{"id":"236","country_code":"VE","country_name":"Venezuela","created":"2017-05-10 11:35:33"},
{"id":"237","country_code":"VN","country_name":"Vietnam","created":"2017-05-10 11:35:33"},
{"id":"238","country_code":"VG","country_name":"Virgin Islands (British)","created":"2017-05-10 11:35:33"},
{"id":"239","country_code":"VI","country_name":"Virgin Islands (U.S.)","created":"2017-05-10 11:35:33"},
{"id":"240","country_code":"WF","country_name":"Wallis and Futuna Islands","created":"2017-05-10 11:35:33"},
{"id":"241","country_code":"EH","country_name":"Western Sahara","created":"2017-05-10 11:35:33"},
{"id":"242","country_code":"YE","country_name":"Yemen","created":"2017-05-10 11:35:33"},
{"id":"243","country_code":"ZR","country_name":"Zaire","created":"2017-05-10 11:35:33"},
{"id":"244","country_code":"ZM","country_name":"Zambia","created":"2017-05-10 11:35:33"},
{"id":"245","country_code":"ZW","country_name":"Zimbabwe","created":"2017-05-10 11:35:33"}]
}



// WEBPACK FOOTER //
// ./src/plugins/scalpert/provider/candle-history/store-addons/state.js